module.exports = __webpack_public_path__ + "media/images/blue_background-ceb14da7a19ad2d74cbaed3d811ec3ca.png";